import React, { useState } from "react";

const StepDSGVO = ({ onNext }) => {
  const [checked, setChecked] = useState(false);

  return (
    <div className="booking-card step-enter">
      <div className="step-badge">Schritt 1 von 6</div>

      <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '26px', fontWeight: 700, color: '#1e2b38', marginBottom: '8px', lineHeight: 1.2, letterSpacing: '-0.02em' }}>
        Kurze Datenschutzinfo
      </h2>
      <p style={{ fontSize: '14px', color: '#6b7a8d', marginBottom: '24px', fontFamily: 'var(--font-ui)', lineHeight: 1.6 }}>
        Deine Angaben werden ausschließlich zur Terminorganisation genutzt und nicht an Dritte weitergegeben (Art. 6 Abs. 1 lit. a DSGVO). Du kannst deine Einwilligung jederzeit widerrufen.
      </p>

      <a
        href="https://zba.academy/datenschutz"
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#6b7a8d', fontFamily: 'var(--font-ui)', textDecoration: 'none', marginBottom: '24px', transition: 'color 150ms ease' }}
        onMouseEnter={e => e.currentTarget.style.color = '#3E4954'}
        onMouseLeave={e => e.currentTarget.style.color = '#6b7a8d'}
      >
        Datenschutzerklärung lesen
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 12h14M12 5l7 7-7 7"/>
        </svg>
      </a>

      <label
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '12px',
          cursor: 'pointer',
          marginBottom: '28px',
          padding: '16px',
          borderRadius: '14px',
          border: checked ? '1.5px solid #3E4954' : '1.5px solid #dde1e7',
          background: checked ? 'rgba(62,73,84,0.05)' : '#f8f9fa',
          transition: 'all 200ms ease',
        }}
      >
        <div
          onClick={() => setChecked(!checked)}
          style={{
            width: '20px',
            height: '20px',
            borderRadius: '6px',
            border: checked ? '2px solid #3E4954' : '2px solid #c5cdd6',
            background: checked ? '#3E4954' : 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            marginTop: '1px',
            transition: 'all 200ms ease',
            cursor: 'pointer',
          }}
        >
          {checked && (
            <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
              <path d="M2 6L5 9L10 3" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>
        <span style={{ fontSize: '14px', color: '#1e2b38', fontFamily: 'var(--font-ui)', lineHeight: 1.6 }}>
          Ich stimme zu und möchte einen Beratungstermin buchen.
        </span>
      </label>

      <button
        className="btn-primary"
        style={{ width: '100%' }}
        disabled={!checked}
        onClick={onNext}
      >
        Weiter
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 12h14M12 5l7 7-7 7"/>
        </svg>
      </button>
    </div>
  );
};

export default StepDSGVO;